import { render, staticRenderFns } from "./PledgeDialog.vue?vue&type=template&id=01f8782f&scoped=true&"
import script from "./PledgeDialog.vue?vue&type=script&lang=js&"
export * from "./PledgeDialog.vue?vue&type=script&lang=js&"
import style0 from "./PledgeDialog.vue?vue&type=style&index=0&id=01f8782f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8782f",
  null
  
)

export default component.exports